import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/** @module others/renderOrderMenu */
import React from "react";
import { Menu, message } from "react-aiot";
import { i18n, IS_DARKMODE, rmlOpts } from "../util";
import { applyToAttachmentsBrowser } from "../hooks/sortable";
var Item = Menu.Item,
    SubMenu = Menu.SubMenu,
    Divider = Menu.Divider;
/**
 * An element rendering sortables for the popup menu.
 *
 * @returns React.Element[]
 */

var createSortables = function createSortables(sortables, select, selectText) {
  return Object.keys(sortables).map(function (key) {
    return /*#__PURE__*/React.createElement(Item, {
      key: key
    }, sortables[key], " ", select === key && /*#__PURE__*/React.createElement("strong", null, "(", selectText, ")"));
  });
};
/**
 * Apply an order to a tree node object and afterwards reload the view.
 *
 * @this AppTree
 */


function applyOrder(_x, _x2, _x3) {
  return _applyOrder2.apply(this, arguments);
}
/**
 * When clicking on a menu item in the order menu popup.
 *
 * @this AppTree
 */


function _applyOrder2() {
  _applyOrder2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(selected, key, automatically) {
    var hide, attachmentsBrowser;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!rmlOpts.others.isPro && rmlOpts.others.showProHints)) {
              _context.next = 4;
              break;
            }

            this.setState({
              showProFeature: "order-content"
            });
            _context.next = 10;
            break;

          case 4:
            hide = message.loading(i18n("orderLoadingText", {
              name: selected.title
            })), attachmentsBrowser = this.attachmentsBrowser;
            _context.next = 7;
            return selected.applyOrder(key, automatically);

          case 7:
            // Apply props to backbone model
            applyToAttachmentsBrowser(attachmentsBrowser, selected);
            this.handleReload();
            hide();

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return _applyOrder2.apply(this, arguments);
}

function handleClick(_x4) {
  return _handleClick.apply(this, arguments);
}
/**
 * Render the order menu.
 *
 * @type React.Element
 */


function _handleClick() {
  _handleClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
    var key, keyPath, path, selected, _applyOrder;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            key = _ref.key, keyPath = _ref.keyPath;
            path = keyPath.reverse(), selected = this.props.store.selected, _applyOrder = applyOrder.bind(this);

            if (path[0] === "dnd") {
              this.handleOrderClick();
            } else if (path[0] === "applyOnce") {
              // Apply sorting once
              _applyOrder(selected, key);
            } else if (path[0] === "applyAutomatically") {
              _applyOrder(selected, key, true);
            } else if (key === "reset") {
              _applyOrder(selected, "original");
            } else if (key === "resetAutomatically") {
              _applyOrder(selected, "deactivate");
            } else if (key === "applyReindex") {
              _applyOrder(selected, "reindex");
            } else if (key === "applyResetLast") {
              _applyOrder(selected, "last");
            }

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));
  return _handleClick.apply(this, arguments);
}

export default function () {
  var store = this.props.store,
      selected = store.selected,
      sortables = store.sortables,
      isSortable = selected && selected.properties && selected.contentCustomOrder !== 2;

  if (!isSortable) {
    return /*#__PURE__*/React.createElement(Menu, {
      style: {
        visibility: "hidden"
      }
    });
  }

  return /*#__PURE__*/React.createElement(Menu, {
    onClick: handleClick.bind(this),
    theme: IS_DARKMODE ? "dark" : "light"
  }, !selected.orderAutomatically && /*#__PURE__*/React.createElement(Item, {
    key: "dnd"
  }, i18n("orderByDnd")), selected.contentCustomOrder !== 0 && /*#__PURE__*/React.createElement(Item, {
    key: "reset"
  }, i18n("resetOrder")), !selected.orderAutomatically && /*#__PURE__*/React.createElement(SubMenu, {
    key: "applyOnce",
    title: i18n("applyOrderOnce"),
    disabled: selected.orderAutomatically
  }, sortables && createSortables(sortables, selected.lastOrderBy, i18n("last"))), selected.orderAutomatically && /*#__PURE__*/React.createElement(Item, {
    key: "resetAutomatically",
    disabled: selected.contentCustomOrder === 0
  }, i18n("deactivateOrderAutomatically")), /*#__PURE__*/React.createElement(SubMenu, {
    key: "applyAutomatically",
    title: i18n("applyOrderAutomatically")
  }, sortables && createSortables(sortables, selected.orderAutomatically && selected.lastOrderBy, i18n("latest"))), selected.contentCustomOrder === 1 && /*#__PURE__*/React.createElement(Divider, null), selected.contentCustomOrder === 1 && /*#__PURE__*/React.createElement(Item, {
    key: "applyReindex"
  }, i18n("reindexOrder")), selected.contentCustomOrder === 1 && /*#__PURE__*/React.createElement(Item, {
    key: "applyResetLast"
  }, i18n("resetToLastOrder")));
}